import React, { useState } from 'react';
import CalendarGrid from '../../components/calendar-grid/index';
import DateSelector from '../../components/data-selector/index'; 
import { Card } from 'react-bootstrap';
import './index.css';

const Agendamento = () => {
    const obterDataInicial = () => {
        const hoje = new Date();
        return hoje;
    };
    const [selectedDate, setSelectedDate] = useState(obterDataInicial());

    const handleNextDay = () => {
        const nextDay = new Date(selectedDate);
        nextDay.setDate(selectedDate.getDate() + 1);
        setSelectedDate(nextDay);
    };

    const handlePrevDay = () => {
        const prevDay = new Date(selectedDate);
        prevDay.setDate(selectedDate.getDate() - 1);
        setSelectedDate(prevDay);
    };

    return (
        <div className="agenda-container">
            <Card className="agendamento-card shadow-sm">
                <Card.Body>
                    <Card.Title className="text-center mb-4">Agenda</Card.Title>
                    <hr />
                    <div className='agendamento-form'>
                        <DateSelector
                            selectedDate={selectedDate}
                            onDateChange={setSelectedDate} 
                            onNextDay={handleNextDay}  
                            onPrevDay={handlePrevDay}
                        />
                    </div>
                    <div className="calendar-grid">
                        <CalendarGrid selectedDate={selectedDate} />
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default Agendamento;
